import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { Role } from 'shared-lib';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private keycloak = inject(Keycloak);

    async checkAccess(role: Role): Promise<boolean> {
        try {
            if (!this.keycloak.authenticated) return false;

            const backendRoles = this.keycloak.resourceAccess?.[environment.auth.clientBackend ?? '']?.roles || [];
            const frontendRoles = this.keycloak.resourceAccess?.[this.keycloak.clientId ?? '']?.roles || [];
            const realmRoles = this.keycloak.realmAccess?.roles || [];

            const hasResource = this.keycloak.hasResourceRole ? this.keycloak.hasResourceRole(role) : false;
            const hasRealm = this.keycloak.hasRealmRole ? this.keycloak.hasRealmRole(role) : false;

            return backendRoles.includes(role) ||
                   frontendRoles.includes(role) ||
                   realmRoles.includes(role) ||
                   hasResource ||
                   hasRealm;
        } catch (error) {
            console.error('Error checking role access:', error);
            return false;
        }
    }

    async getRoles(): Promise<string[]> {
        try {
            if (!this.keycloak.authenticated) return [];

            const backendRoles = this.keycloak.resourceAccess?.[environment.auth.clientBackend ?? '']?.roles || [];
            const clientRoles = this.keycloak.resourceAccess?.[this.keycloak.clientId ?? '']?.roles || [];
            const realmRoles = this.keycloak.realmAccess?.roles || [];

            return Array.from(new Set([...backendRoles, ...clientRoles, ...realmRoles]));
        } catch (error) {
            console.error('Error getting user roles:', error);
            return [];
        }
    }

    isAuthenticated(): boolean {
        return !!this.keycloak.authenticated;
    }
}